import React from 'react'
import { useQuery } from '@apollo/client'
import fetchGroups from '../queries/group-list'

const goToGroups = (projectId) => {
  const search = projectId ? `?project_id=${projectId}` : ''
  window.location.href = `/groups${search}`
}

const Group = ({ name, onClick }) => {
  return (
    <div className="option" onClick={onClick}>
      {name}
    </div>
  )
}

function GroupSelect(props) {
  const [showOptions, setShowOptions] = React.useState(false)
  const { loading, data } = useQuery(fetchGroups)

  if (loading) return <div>loading</div>

  const toggleOptions = () => {
    setShowOptions(!showOptions)
  }

  const onSelect = (group) => {
    props.onSelect(group)
    toggleOptions()
  }
  const { projectId, selected } = props
  const optionsClass = showOptions ? 'options active' : 'options'
  const activeOwnedGroups =
    data.ownedGroups && data.ownedGroups.filter((g) => !g.archived)
  const activeOtherGroups =
    data.otherGroups && data.otherGroups.filter((g) => !g.archived)

  return (
    <div className="select">
      <div className="trigger" onClick={toggleOptions}>
        <span>{selected ? selected.name : 'Select Group'}</span>
        <i className="material-icons">keyboard_arrow_down</i>
      </div>
      <input
        type="text"
        name="group"
        value={selected}
        onFocus={toggleOptions}
        onBlur={toggleOptions}
      />
      <div className={optionsClass}>
        <div className="option-group">
          <label>My Groups</label>
          {activeOwnedGroups &&
            activeOwnedGroups.map((g) => (
              <Group key={g.id} name={g.name} onClick={() => onSelect(g)} />
            ))}
        </div>
        <div className="option-group">
          <label>Other Groups</label>
          {activeOtherGroups &&
            activeOtherGroups.map((g) => (
              <Group key={g.id} name={g.name} onClick={() => onSelect(g)} />
            ))}
        </div>
        <footer>
          <a onClick={() => goToGroups(projectId)}>
            <i className="material-icons">add_circle</i>
            Create New Group
          </a>
        </footer>
      </div>
    </div>
  )
}

export default GroupSelect
